export default __webpack_public_path__ + "static/media/Create-documentation.49a1cd23.md";